"use strict";
import * as utility from "./_utility";
import * as animation from "./_animation";
import { gsap, Power3, Power0 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
smoothscroll.polyfill();
animation.init();
window.addEventListener("DOMContentLoaded", () => {
  document.body.style.opacity = "0";
  // メディアクエリ定数
  // if (window.matchMedia("(max-width: 767px)").matches) {
  //   //スマホ処理
  //   // document.querySelector(".clickablemap--pc").remove();
  // } else if (window.matchMedia("(min-width:768px)").matches) {
  //   document.querySelector(".smp-header").remove();
  //   //PC処理
  // }
});
window.addEventListener("load", () => {
  setTimeout(() => {
    document.body.style.opacity = "1";
    document.body.classList.add("loaded");
  }, 200);
  utility.setupCSSCustomProperties();
});

// コンテナクエリポリフィル
const supportsContainerQueries = "container" in document.documentElement.style;
if (!supportsContainerQueries) {
  import("container-query-polyfill");
}

// - - - - - - - - - - - - - - - - - - - -
//
// rel header
//
// - - - - - - - - - - - - - - - - - - - -
document
  .querySelectorAll(".header-button, .header-nav__item")
  .forEach((target) => {
    target.addEventListener("click", () => {
      target.classList.toggle("is-active");
      document.querySelector(".js-header-wrap").classList.toggle("is-active");
      document.querySelector(".header").classList.toggle("is-active");
      document
        .querySelector(".header-button__line")
        .classList.toggle("is-active");

      // lock.scrollLock();
    });
  });

// - - - - - - - - - - - - - - - - - - - -
//
// rel special movie
//
// - - - - - - - - - - - - - - - - - - - -
window.addEventListener("DOMContentLoaded", () => {
  const movieClose = document.querySelector(".close-button");
  let movieModal = document.querySelector(".special-movie");
  movieClose.addEventListener("click", () => {
    movieModal.classList.remove("slide-down");
    player.stopVideo();
    document.body.style.overflow = "";
    // setTimeout(() => {
    //   kvSwiper.autoplay.start();
    // }, "2000");
  });
  const movieOpen = document.querySelectorAll(".movie-open");
  movieOpen.forEach((item) => {
    item.addEventListener("click", () => {
      movieModal.classList.add("slide-down");
      document.body.style.overflow = "hidden";
    });
  });
});

// - - - - - - - - - - - - - - - - - - - - - - - - - -
//
// rel Animation
//
// - - - - - - - - - - - - - - - - - - - - - - - - - -
window.addEventListener("load", () => {
  countUp();
  animTrigger();
  // animTitle();
  animLetters();
  spanWrapText();
});
function countUp() {
  // カウントアップアニメーション
  animation.gsap.utils.toArray(".count").forEach((item) => {
    let count = item.dataset.count;
    animation.gsap.to(item, {
      textContent: count,
      duration: 1,
      // delay: 0.5,
      ease: "power4.inout",
      snap: { textContent: Number.isInteger(parseFloat(count)) ? 1 : 0.1 }, // 整数と小数点で処理を変える
      stagger: {
        onUpdate: function () {
          this.targets()[0].innerHTML = numberWithCommas(
            this.targets()[0].textContent
          );
        },
      },
      scrollTrigger: {
        // markers: true,
        trigger: item,
        start: "top 84%",
        // scroller: ".container__main",
      },
    });
  });
  // 3ケタ以降にカンマをつける
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
function animTrigger() {
  // inview的アニメトリガー
  const animTarget = document.querySelectorAll(".animItem");
  animTarget.forEach((item, index) => {
    gsap.to(item, {
      scrollTrigger: {
        // scroller: ".container__main",
        trigger: item,
        start: "top 85%",
        once: true,
        // markers: true,
        toggleClass: {
          targets: item,
          className: "is-visible",
        },
        stagger: 0.3,
      },
    });
  });
}
function spanWrapText() {
  const spanWrapText = (target) => {
    const nodes = [...target.childNodes]; // ノードリストを配列にする
    let returnText = ""; // 最終的に返すテキスト

    for (const node of nodes) {
      if (node.nodeType == 3) {
        //テキストの場合
        const text = node.textContent.replace(/\r?\n/g, ""); //テキストから改行コード削除
        const splitText = text.split(""); // 一文字ずつ分割
        for (const char of splitText) {
          returnText += `<span>${char}</span>`; // spanタグで挟んで連結
        }
      } else {
        //テキスト以外の場合
        //<br>などテキスト以外の要素をそのまま連結
        returnText += node.outerHTML;
      }
    }
    return returnText;
  };
}
function animLetters() {
  const animLetters = document.querySelectorAll(".anim-letter");
  for (const letter of animLetters) {
    letter.innerHTML = spanWrapText(letter);
    letter.spans = letter.querySelectorAll("span");
  }

  const animLettersSet = {
    display: "inline-block",
    overflow: "hidden",
    opacity: 0,
    x: -20,
    duration: 0.8,
    ease: "power2.out",
  };
  const animLettersTo = {
    opacity: 1,
    x: 0,
    stagger: 0.03,
  };
  animLetters.forEach((item, index) => {
    const child = item.getElementsByTagName("span");
    gsap.set(child, animLettersSet);
    gsap.to(child, {
      ...animLettersTo,
      scrollTrigger: {
        trigger: item,
        // scroller: ".container__inner",
        start: "top 85%",
        // markers: true,
      },
    });
  });
}
function animTitle() {
  const animTitle = document.querySelectorAll(".anim-title");

  const animTitleSet = {
    overflow: "hidden",
    opacity: 0,
    y: 20,
    duration: 0.6,
    ease: "power2.out",
  };
  const animTitleTo = {
    opacity: 1,
    y: 0,
  };
  animTitle.forEach((item, index) => {
    gsap.set(item, animTitleSet);
    gsap.to(item, {
      ...animTitleTo,
      scrollTrigger: {
        trigger: item,
        start: "top 90%",
      },
    });
  });
}

// - - - - - - - - - - - - - - - - - - - -
//
// rel container
//
// - - - - - - - - - - - - - - - - - - - -

const navItems = document.querySelectorAll(".container-nav__item");
const sections = document.querySelectorAll(".container-section");
const currentShip = document.querySelector(".nav-icon");
const targetSections = gsap.utils.toArray(".target-section");
const targetFigures = gsap.utils.toArray(".target-figure");
const pageTop = document.querySelector(".stickey-footer");

// セクションとナビゲーションのスクロールトリガーを設定
sections.forEach((section, index) => {
  // セクションのスクロールトリガー
  ScrollTrigger.create({
    trigger: section,
    start: "top 65%",
    endTrigger: ".footer",
    end: "bottom top",
  });

  ScrollTrigger.create({
    trigger: section,
    start: "top 55%",
    endTrigger: ".footer",
    end: "bottom top",
    toggleClass: {
      targets: currentShip,
      className: `section${index + 1}`,
    },
  });

  // ナビゲーションアイテムのスクロールトリガー
  if (index < navItems.length) {
    gsap.to(section, {
      scrollTrigger: {
        trigger: section,
        start: "top center",
        end: "bottom 50%",
        toggleClass: {
          targets: navItems[index],
          className: "current",
        },
      },
    });
  }
});

// ターゲットセクションとフィギュアのスクロールトリガーを設定
targetSections.forEach((section, i) => {
  if (i < targetFigures.length) {
    ScrollTrigger.create({
      trigger: section,
      start: "top 50%",
      endTrigger: ".footer",
      end: "bottom -5%",
      toggleClass: {
        targets: targetFigures[i],
        className: "is-view",
      },
    });
  }
});

// ページトップのスクロールトリガーを設定
ScrollTrigger.create({
  trigger: sections[1] || ".footer", // 2番目のセクションがない場合はフッターをトリガーにする
  start: "top top",
  endTrigger: ".footer",
  end: "top center",
  toggleClass: {
    targets: pageTop,
    className: "is-view",
  },
});
